<template>
  <v-container>
    <h1 class="mb-4">Employee Comparison</h1>
    
    <v-card class="mb-4">
      <v-card-title>Filters</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-menu
              v-model="dateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filters.dateOfJoining"
                  label="Date of Joining"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.dateOfJoining"
                @input="dateMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="filters.grade"
              :items="gradeOptions"
              label="Grade"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-select
              v-model="filters.highestQualification"
              :items="qualificationOptions"
              label="Highest Qualification"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="filters.additionalQualification"
              label="Additional Qualification"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="filters.certificationCourses"
              label="Certification Courses"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model.number="filters.workExperience"
              label="Work Experience (years) before WTI"
              type="number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model.number="filters.joiningSalary"
              label="Joining Salary"
              type="number"
              outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model.number="filters.currentSalary"
              label="Current Salary"
              type="number"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="compareEmployees">Compare</v-btn>
      </v-card-actions>
    </v-card>

    <v-row v-if="comparisonResults.length">
      <v-col v-for="employee in comparisonResults" :key="employee.id" cols="12" sm="6" md="4">
        <v-card>
          <v-card-title>{{ employee.name }}</v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item v-for="(value, key) in employee" :key="key">
                <v-list-item-content>
                  <v-list-item-title>{{ formatKey(key) }}</v-list-item-title>
                  <v-list-item-subtitle>{{ value }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EmployeeComparison',
  data() {
    return {
      dateMenu: false,
      filters: {
        dateOfJoining: null,
        grade: null,
        highestQualification: null,
        additionalQualification: null,
        certificationCourses: null,
        workExperience: null,
        joiningSalary: null,
        currentSalary: null,
      },
      gradeOptions: ['Grade A', 'Grade B', 'Grade C'], // Add your grade options
      qualificationOptions: ['Bachelor', 'Master', 'PhD'], // Add your qualification options
      comparisonResults: [],
    };
  },
  methods: {
    compareEmployees() {
      // Call the API with the filters
      axios.post('/api/compare-employees', this.filters, {
        headers: {
          'x-auth-token': localStorage.getItem('token'),
        },
      })
        .then(response => {
          this.comparisonResults = response.data;
        })
        .catch(error => {
          console.error('Error comparing employees:', error);
          // Handle error (e.g., show an error message to the user)
        });
    },
    formatKey(key) {
      return key.split(/(?=[A-Z])/).join(' ').replace(/^\w/, c => c.toUpperCase());
    },
  },
};
</script>